import { NumberFormatType } from '../enum/formatPricePercentEnum';
import formatterNumber from './formatterNumber';

export default function formatterPrice(
  value: number,
  options?: Intl.NumberFormatOptions,
) {
  return formatterNumber(value, {
    style: NumberFormatType.currency,
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options,
  });
}
